<form [formGroup]="form">
  <fieldset>
    <div class="form-row" style="display: flex; gap: 1rem">
      <div class="col-6 mb-3" style="flex: 1">
        <div class="row">
          <label class="label col-12 col-form-label">Agent *</label>
          <div class="form-text mb-1">Sélectionnez l'agent.</div>
          <mat-form-field class="w-100">
            <mat-select formControlName="agent" required [compareWith]="compareById">
              @for (agent of agentsList; track agent) {
                <mat-option [value]="agent"> {{ agent.nom }} {{ agent.prenom }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-6 mb-3" style="flex: 1">
        <div class="row">
          <label class="label col-12 col-form-label">Type de renouvellement *</label>
          <div class="form-text mb-1">Sélectionnez le type de renouvellement.</div>
          <mat-form-field class="w-100">
            <input
              type="text"
              matInput
              aria-label="Type de renouvellement"
              name="Type de renouvellement"
              [matAutocomplete]="autoTyperenouvellement"
              formControlName="typeRenouvellement"
              (input)="filterRenouvellementList($event)"
              />
              @if (form.get('typeRenouvellement')?.value && !form.get('typeRenouvellement')?.disabled) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="effaceFiltreTypeRen($event, 'typeRenouvellement')"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete
                hideSingleSelectionIndicator
                requireSelection
                #autoTyperenouvellement="matAutocomplete"
                [displayWith]="typeRenouvellementdisplayFn"
                >
                @for (type of recrutementListFiltered; track type) {
                  <mat-option [value]="type">
                    {{ type.libelle }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (form.get('typeRenouvellement')?.hasError('required') && form.get('typeRenouvellement')?.touched) {
                <mat-error>
                  Le type de renouvellement est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Catégorie de poste</label>
            <div class="form-text mb-1">Sélectionnez la catégorie du poste.</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="categoriePoste" [compareWith]="compareById">
                @for (categorie of categoriePosteList; track categorie) {
                  <mat-option [value]="categorie">
                    {{ categorie.code }}
                  </mat-option>
                }
              </mat-select>
              <!-- categoriePoste is never required per business rules -->
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Identifiant agent *</label>
            <div class="form-text mb-1">Sélectionnez l'identifiant de l'agent.</div>
            <mat-form-field class="w-100">
              <input matInput formControlName="identifiantAgent" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Grade *</label>
            <div class="form-text mb-1">Sélectionnez le grade.</div>
            <mat-form-field class="w-100">
              <input matInput formControlName="grade" />
              @if (form.get('grade')?.hasError('required') && form.get('grade')?.touched) {
                <mat-error> Le grade est obligatoire. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Entrée dans l'organisation *</label>
            <div class="form-text mb-1">Sélectionnez ou saisissez une date au format DD/MM/YYYY.</div>
            <mat-form-field class="w-100">
              <input matInput [matDatepicker]="dateEntreePicker" formControlName="dateEntree" required />
              <mat-datepicker-toggle matSuffix [for]="dateEntreePicker"></mat-datepicker-toggle>
              <mat-datepicker #dateEntreePicker></mat-datepicker>
              @if (form.get('dateEntree')?.hasError('required') && form.get('dateEntree')?.touched) {
                <mat-error>
                  La date d'entrée est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Poste occupé *</label>
            <div class="form-text mb-1">Sélectionnez le poste occupé.</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="posteOccupe" required [compareWith]="compareById">
                @for (poste of posteList; track poste) {
                  <mat-option [value]="poste">
                    {{ poste.libelle }}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('posteOccupe')?.hasError('required') && form.get('posteOccupe')?.touched) {
                <mat-error>
                  Le poste occupé est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Taux d'emploi *</label>
            <div class="form-text mb-1">Sélectionnez le taux d'emploi.</div>
            <mat-form-field class="w-100">
              <input matInput formControlName="tauxEmploi" type="number" required />
              <span matSuffix>%</span>
              @if (form.get('tauxEmploi')?.hasError('required') && form.get('tauxEmploi')?.touched) {
                <mat-error>
                  Le taux d'emploi est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Fonction de l'agent *</label>
            <div class="form-text mb-1">Sélectionnez la fonction de l'agent.</div>
            <mat-form-field class="w-100">
              <input matInput formControlName="fonction" />
              @if (form.get('fonction')?.hasError('required') && form.get('fonction')?.touched) {
                <mat-error>
                  La fonction est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-3" style="flex: 1">
          <label for="tauxEmploi" class="label col-6 col-form-label text-nowrap">Date d'expiration de la carte de séjour</label>
          <div class="form-text mb-1">Date d'expiration carte de séjour, format date DD/MM/YYYY.</div>
          <mat-form-field class="w-100">
            <input matInput [disabled]="true" [value]="dateExpirationCS" />
          </mat-form-field>
        </div>
      </div>
      <mat-divider style="border-top: 3px solid black"></mat-divider>
      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Pôle *</label>
            <div class="form-text mb-1">Sélectionnez le pole (Famille, attractivité et cohésion ...).</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="pole" required [compareWith]="compareById">
                @for (pole of poleList; track pole) {
                  <mat-option [value]="pole">
                    {{ pole.libelle }}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('pole')?.hasError('required') && form.get('pole')?.touched) {
                <mat-error> Le pôle est obligatoire. </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Direction *</label>
            <div class="form-text mb-1">Sélectionnez la direction.</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="direction" required [compareWith]="compareById">
                @for (direction of directionList; track direction) {
                  <mat-option [value]="direction">
                    {{ direction?.libelle }}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('direction')?.hasError('required') && form.get('direction')?.touched) {
                <mat-error>
                  La direction est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Service ou unité de rattachement</label>
            <div class="form-text mb-1">Sélectionnez le service ou unité de rattachement.</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="serviceFonctionnel" required [compareWith]="compareById">
                @for (service of serviceFonctionnelList; track service) {
                  <mat-option [value]="service">
                    {{ displayService(service) }}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('serviceFonctionnel')?.hasError('required') && form.get('serviceFonctionnel')?.touched) {
                <mat-error>
                  Le service fonctionnel est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Type de contrat *</label>
            <div class="form-text mb-1">Sélectionnez le type de contrat.</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="typeContrat" required [compareWith]="compareById">
                @for (type of typeContratList; track type) {
                  <mat-option [value]="type">
                    {{ type.libelle }}
                  </mat-option>
                }
              </mat-select>
              @if (form.get('typeContrat')?.hasError('required') && form.get('typeContrat')?.touched) {
                <mat-error>
                  Le type de contrat est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-row" style="display: flex; gap: 1rem">
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Agent remplacé *</label>
            <div class="form-text mb-1">Sélectionnez (oui, non).</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="agentRemplace" required>
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
              @if (form.get('agentRemplace')?.hasError('required') && form.get('agentRemplace')?.touched) {
                <mat-error>
                  Ce champ est obligatoire.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 mb-3" style="flex: 1">
          <div class="row">
            <label class="label col-12 col-form-label">Début - fin contrat *</label>
            <div class="form-text mb-1">Sélectionnez la période du contrat.</div>
            <mat-form-field class="w-100">
              <mat-date-range-input [formGroupName]="'dateRange'" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Date de début" />
                <input matEndDate formControlName="end" placeholder="Date de fin" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
              @if (form.get('dateRange.start')?.hasError('required')) {
                <mat-error> La date de début est obligatoire </mat-error>
              }
              @if (form.get('dateRange.end')?.hasError('required')) {
                <mat-error> La date de fin est obligatoire </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
